/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorTrue extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorTrue");
    }

    getFixupPrototypeFunction() { return QueryOperatorTrue.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorTrue>): QueryOperatorTrue {
        let obj = Object.assign(new QueryOperatorTrue(), model);
        QueryOperatorTrue.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorTrue>): QueryOperatorTrue {
        if (!model) return null;
        return QueryOperatorTrue.newInstance(<QueryOperatorTrue> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorTrue) {
        if (!obj) return;

        models.QueryOperatorTrue.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorTrue): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorTrue.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
